var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { startCase } from "lodash";
import styled from "styled-components";
import { Text } from "../Text";
import { NavigationItem, NavigationList } from "../Navigation/List";
const StyledList = styled(NavigationList)({
    "&&": { margin: "0px" },
    border: "none",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    width: "100%",
});
const StyledItem = styled(NavigationItem)(({ interactive, onClick, selected, theme: { colors: { deprecatedSearchBoxColors }, shadows: { listItemBottomShadow }, }, }) => (Object.assign(Object.assign({}, (onClick && interactive
    ? {
        "&:hover": {
            background: deprecatedSearchBoxColors.autocompleteHoverBackground,
            color: deprecatedSearchBoxColors.autocompleteHoverText,
        },
        cursor: "pointer",
    }
    : {})), { backgroundColor: selected
        ? deprecatedSearchBoxColors.autocompleteSelectedBackground
        : deprecatedSearchBoxColors.autocompleteBackground, boxShadow: listItemBottomShadow, color: deprecatedSearchBoxColors.autocompleteText, display: "inline", paddingLeft: 26 })));
const StyledText = styled(Text)(({ theme: { colors: { deprecatedSearchBoxColors }, shadows: { listItemBottomShadow }, }, }) => ({
    boxShadow: listItemBottomShadow,
    color: deprecatedSearchBoxColors.autocompleteText,
    fontWeight: "bold",
}));
export const onSelect = (index, filters, onItemSelect) => {
    if (!(index in filters))
        return;
    const filter = filters[index];
    if (onItemSelect)
        onItemSelect(filter);
};
const Title = (props) => React.createElement(StyledText, Object.assign({ as: "li", fontFamily: "bold", py: 2, px: 2 }, props));
export const AutocompleteResults = (_a) => {
    var { collection, search, onItemSelect } = _a, props = __rest(_a, ["collection", "search", "onItemSelect"]);
    const filters = [];
    let index = 0;
    const child = [];
    collection.forEach(({ items, indeterminate = false, title }, pos) => {
        if (!items)
            return;
        if (indeterminate) {
            filters[index] = { name: title, value: search };
            child.push(React.createElement(Title, { key: `title-${pos}` }, startCase(title === "any" ? "search all" : title)));
            child.push(React.createElement(StyledItem, { key: index, index: index, label: search }));
            index += 1;
            return;
        }
        if (collection.length > 1 && title && items.length > 0) {
            child.push(React.createElement(Title, { key: `title-${pos}` }, `${startCase(title)} [${items.length} results]`));
        }
        items.forEach(({ value, id }) => {
            filters[index] = { id, name: title, value };
            child.push(React.createElement(StyledItem, { key: index, index: index, label: value }));
            index += 1;
        });
    });
    if (child.length === 0) {
        child.push(React.createElement(Title, { key: 0 }, "No results"));
    }
    return (React.createElement(StyledList, Object.assign({ "data-testid": "AutocompleteResults", maxHeight: "300px", onItemSelect: (idx) => onSelect(idx, filters, onItemSelect) }, props), child));
};
